import {useRequest} from 'vue-request'
import axiosHelper from "webapp-react/src/shared/axios.helper";

export const fetchPayoutCountries = async () => {
  return await axiosHelper.get('/webapi/finance/payout/countries').then(
    (response) => {
      return response.data;
    }
  );
}

export const usePayoutCountries = (options = {}) => {
  return useRequest(fetchPayoutCountries, {
    cacheKey: '/webapi/finance/payout/countries',
    cacheTime: 600000,
    errorRetryCount: 6,
    errorRetryInterval: 3000,
    // pollingInterval: 600000,
    debounceInterval: 300,
    ...options
  })
}
